import { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

// @mui material components
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import InputAdornment from "@mui/material/InputAdornment";

// Material Dashboard 3 PRO React components
import MDInput from "components/MDInput";

import FormSelect from "components/DigiHapi/FormSelect";

import {
	fetchGetAddressUsingZipCode,
	fetchGetCityUsingZipCode,
	fetchGetAddressUsingCoordinates
} from "actions/datagouv";

import {
	CLEAR_ORGANIZATION_FAX,
	CLEAR_ORGANIZATION_PHONE,
	CLEAR_ORGANIZATION_WEB_SITE_URL,
	SET_ORGANIZATION_ADDRESS,
	SET_ORGANIZATION_CITY,
	SET_ORGANIZATION_FAX,
	SET_ORGANIZATION_FAX_ERROR,
	SET_ORGANIZATION_PHONE,
	SET_ORGANIZATION_PHONE_ERROR,
	SET_ORGANIZATION_WEB_SITE_URL,
	SET_ORGANIZATION_WEB_SITE_URL_ERROR,
	SET_ORGANIZATION_ZIP_CODE,
	SET_ORGANIZATION_SELECTED_CITY,
	SET_ORGANIZATION_SELECTED_ADDRESS,
	SET_ORGANIZATION_SELECTED_ZIPCODE
} from "actions/types";
import PhoneMaskInput from "components/DigiHapi/PhoneMaskInput";

const OTHER = "Autre ...";

// Select options built from the keys of the datagouv results
const toOptions = data =>
	Object.keys(data || {}).map(key => ({ value: key, label: key }));

// Red cross used to clear a field
const clearAdornment = onClick => (
	<InputAdornment position="end">
		<Icon color="error" sx={{ cursor: "pointer" }} onClick={onClick}>
			close
		</Icon>
	</InputAdornment>
);

class Step2 extends Component {
	sendState() {
		return this.state;
	}

	isValidated() {
		const { dispatch, phoneState, faxState, webSiteUrlState } = this.props;

		let success = true;
		if (phoneState === "error") {
			dispatch({
				type: SET_ORGANIZATION_PHONE_ERROR
			});
			success = false;
		}
		if (faxState === "error") {
			dispatch({
				type: SET_ORGANIZATION_FAX_ERROR
			});
			success = false;
		}
		if (webSiteUrlState === "error") {
			dispatch({
				type: SET_ORGANIZATION_WEB_SITE_URL_ERROR
			});
			success = false;
		}
		// if (mailState === "error") {
		// 	dispatch({
		// 		type: SET_ORGANIZATION_MAIL_ERROR
		// 	});
		// 	success = false;
		// }
		return success;
	}

	render() {
		const {
			dispatch,
			phone,
			phoneState,
			phoneErrorMsg,
			fax,
			faxState,
			faxErrorMsg,
			customAddress,
			address,
			addresses,
			selectedAddress,
			addressUpdated,
			zipCodes,
			selectedZipCode,
			customZipCode,
			zipCode,
			zipCodeUpdated,
			cities,
			selectedCity,
			customCity,
			webSiteUrl,
			webSiteUrlState,
			webSiteUrlErrorMsg,
			longitude,
			latitude
		} = this.props;
		return (
			<Grid container spacing={3} justifyContent="center">
				{selectedAddress === OTHER ? (
					<Grid item xs={12}>
						<MDInput
							label="Adresse"
							id="address"
							fullWidth
							value={customAddress ? customAddress : ""}
							onChange={e =>
								dispatch({
									type: SET_ORGANIZATION_ADDRESS,
									value: e.target.value
								})
							}
							onBlur={() => {
								if (addressUpdated && address) {
									if (zipCode) {
										this.props.fetchGetAddressUsingZipCode({
											address,
											zipCode
										});
									} else if (longitude && latitude) {
										this.props.fetchGetAddressUsingCoordinates({
											address,
											latitude,
											longitude
										});
									}
								}
							}}
						/>
					</Grid>
				) : (
					<Grid item xs={12}>
						<FormSelect
							label="Adresse"
							value={selectedAddress}
							placeholder={OTHER}
							placeholderSelectable
							options={toOptions(addresses)}
							onChange={(e, child) =>
								dispatch({
									type: SET_ORGANIZATION_SELECTED_ADDRESS,
									payload: child.props.children
								})
							}
						/>
					</Grid>
				)}
				{selectedZipCode === OTHER ? (
					<Grid item xs={12}>
						<MDInput
							label="Code postal"
							id="zipcode"
							fullWidth
							value={customZipCode ? customZipCode : ""}
							onChange={e =>
								dispatch({
									type: SET_ORGANIZATION_ZIP_CODE,
									value: e.target.value
								})
							}
							onBlur={() =>
								zipCodeUpdated &&
								zipCode &&
								this.props.fetchGetCityUsingZipCode({ address, zipCode })
							}
						/>
					</Grid>
				) : (
					<Grid item xs={12}>
						<FormSelect
							label="Code postal"
							value={selectedZipCode}
							placeholder={OTHER}
							placeholderSelectable
							options={toOptions(zipCodes)}
							onChange={(e, child) =>
								dispatch({
									type: SET_ORGANIZATION_SELECTED_ZIPCODE,
									payload: child.props.children
								})
							}
						/>
					</Grid>
				)}
				{selectedCity === OTHER ? (
					<Grid item xs={12}>
						<MDInput
							label="Ville"
							id="city"
							fullWidth
							value={customCity ? customCity : ""}
							onChange={e =>
								dispatch({
									type: SET_ORGANIZATION_CITY,
									value: e.target.value
								})
							}
						/>
					</Grid>
				) : (
					<Grid item xs={12}>
						<FormSelect
							label="Ville"
							value={selectedCity}
							placeholder={OTHER}
							placeholderSelectable
							options={toOptions(cities)}
							onChange={(e, child) =>
								dispatch({
									type: SET_ORGANIZATION_SELECTED_CITY,
									payload: child.props.children
								})
							}
						/>
					</Grid>
				)}
				<Grid item xs={12}>
					<MDInput
						label="Téléphone"
						id="phone"
						fullWidth
						success={!!phone && phoneState === "success"}
						error={phoneState === "error"}
						helperText={phoneErrorMsg}
						placeholder="+33 (0)X XX XX XX XX"
						value={phone ? phone : ""}
						onChange={e =>
							dispatch({
								type: SET_ORGANIZATION_PHONE,
								value: e.target.value
							})
						}
						InputProps={{
							inputComponent: PhoneMaskInput,
							endAdornment:
								phone !== null &&
								clearAdornment(() =>
									dispatch({
										type: CLEAR_ORGANIZATION_PHONE
									})
								)
						}}
					/>
				</Grid>
				<Grid item xs={12}>
					<MDInput
						label="Fax"
						id="fax"
						fullWidth
						success={!!fax && faxState === "success"}
						error={faxState === "error"}
						helperText={faxErrorMsg}
						placeholder="+33 (0)X XX XX XX XX"
						value={fax ? fax : ""}
						onChange={e =>
							dispatch({
								type: SET_ORGANIZATION_FAX,
								value: e.target.value
							})
						}
						InputProps={{
							inputComponent: PhoneMaskInput,
							endAdornment:
								fax !== null &&
								clearAdornment(() =>
									dispatch({
										type: CLEAR_ORGANIZATION_FAX
									})
								)
						}}
					/>
				</Grid>
				<Grid item xs={12}>
					<MDInput
						label="Url site internet"
						id="url"
						type="text"
						fullWidth
						success={!!webSiteUrl && webSiteUrlState === "success"}
						error={webSiteUrlState === "error"}
						helperText={webSiteUrlErrorMsg}
						value={webSiteUrl ? webSiteUrl : ""}
						onChange={e =>
							dispatch({
								type: SET_ORGANIZATION_WEB_SITE_URL,
								value: e.target.value
							})
						}
						InputProps={{
							endAdornment:
								webSiteUrl !== null &&
								clearAdornment(() =>
									dispatch({
										type: CLEAR_ORGANIZATION_WEB_SITE_URL
									})
								)
						}}
					/>
				</Grid>
			</Grid>
		);
	}
}

const mapStateToProps = state => {
	const {
		_id,
		isFetching,
		isFetchingList,
		name,
		nameErrorMsg,
		addressUpdated,
		customAddress,
		addresses,
		selectedAddress,
		address,
		customZipCode,
		zipCodes,
		selectedZipCode,
		zipCode,
		zipCodeUpdated,
		customCity,
		city,
		cities,
		selectedCity,
		webSiteUrl,
		mail,
		latitude,
		longitude,
		phone,
		fax,
		registerkey,
		files,
		logoUri,
		mapUri,
		mapSmallUri,
		phoneErrorMsg,
		phoneState,
		faxErrorMsg,
		faxState,
		webSiteUrlState,
		webSiteUrlErrorMsg,
		mailState,
		mailErrorMsg
	} = state.organizationReducer;
	return {
		_id,
		isFetching,
		isFetchingList,
		name,
		nameErrorMsg,
		address,
		customAddress,
		addresses,
		selectedAddress,
		addressUpdated,
		zipCode,
		customZipCode,
		zipCodes,
		selectedZipCode,
		zipCodeUpdated,
		customCity,
		city,
		cities,
		selectedCity,
		webSiteUrl,
		mail,
		latitude,
		longitude,
		phone,
		fax,
		registerkey,
		files,
		logoUri,
		mapUri,
		mapSmallUri,
		phoneErrorMsg,
		phoneState,
		faxErrorMsg,
		faxState,
		webSiteUrlState,
		webSiteUrlErrorMsg,
		mailState,
		mailErrorMsg
	};
};

const mapDispatchToProps = dispatch => {
	let actions = bindActionCreators(
		{
			fetchGetAddressUsingZipCode,
			fetchGetCityUsingZipCode,
			fetchGetAddressUsingCoordinates
		},
		dispatch
	);
	return { ...actions, dispatch };
};
export default connect(mapStateToProps, mapDispatchToProps, null, {
	forwardRef: true
})(Step2);
